import $ from "jquery";

$(() => {
  var path = window.location.pathname;
  if (path.startsWith("/admin/fields/")) {
    initModule();
  }
});

function initModule() {
  $("#field_type").on("change", function () {
    var enable = false;
    if ($(this).val() === "list") {
      enable = true;

      $("#list").children(".list-disabled").remove();
    } else {
      $("#list").append(`<option class="list-disabled" selected></option>`);
    }

    $("#list").prop("disabled", !enable);
    $("#list").prop("required", enable);
  });

  $("#field_type").trigger("change");
}
